import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import React from 'react';

export const LegalReport = lazy(
  () =>
    import(
      '@aboutyou/logic-components/src/features/LegalReport/LegalReportPage'
    ).then(mod => ({
      default: mod.LegalReportPage,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
    isSsrAndNeedsHydration: true,
  },
);
